<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    title="Send Invitation"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :width="400"
    :height="300"
    container=".dx-viewport"
    @hiding="closePopup"
  >
    <div class="popup-content p-4">
      <div class="flex justify-center mb-6">
        <img src="\imgs\aruvaa_logo.png" alt="Company Logo" class="h-10" />
      </div>
     
      <div class="text-center mb-6">
        <h3 class="text-lg font-medium">Enter the user's Email ID:</h3>
        <input
          type="email"
          v-model="email"
          placeholder="user@example.com"
          class="mt-2 w-full px-4 py-2 border border-gray-300 rounded text-center"
        />
       
      
      </div>
      
      <div v-if="sending" class="text-center mb-4">
        <i class="fas fa-paper-plane fa-spin mr-2"></i> Sending invitation...
      </div>
      
      <div v-if="success" class="bg-green-100 text-green-700 p-2 rounded text-center mb-4">
        {{ success }}
      </div>
      
      <div v-if="sendError" class="bg-red-100 text-red-700 p-2 rounded text-center mb-4">
        {{ sendError }}
      </div>
     
      <div class="flex justify-center mt-6 space-x-4">
        <button
          @click="closePopup"
          class="px-6 py-2 bg-gray-300 text-gray-700 font-medium rounded hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          @click="sendInvitation"
          class="px-6 py-2 bg-green-500 text-white font-medium rounded hover:bg-green-600 flex items-center"
          :disabled="!isValidSelection || sending"
        >
          <i class="fas fa-paper-plane mr-2"></i>
          Send Invite
        </button>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';

export default {
  components: {
    DxPopup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    slug: String,
    moduleRoute: String
  },
  data() {
    return {
      email: '',
      selectedUser: '',
      users: [],
      loading: false,
      error: null,
      sending: false,
      success: null,
      sendError: null
    };
  },
  computed: {
    isValidSelection() {
      return this.email || this.selectedUser;
    }
  },
  methods: {
    // fetchUsers() {
    //   this.loading = true;
    //   this.error = null;
      
    //   // Use axios instead of Inertia for direct API calls
    //   axios.get(`/${this.slug}/Employee/getuserlist`)
    //     .then(response => {
    //       console.log("Users data:", response.data);
    //       // The response is a plain JSON with a data array
    //       this.users = response.data.data || [];
    //       this.loading = false;
    //     })
    //     .catch(error => {
    //       console.error("Error fetching users:", error);
    //       this.error = "Failed to load users. Please try again.";
    //       this.loading = false;
    //     });
    // },
   
    sendInvitation() {
      const emailToSend = this.email || this.selectedUser;
      if (emailToSend) {
        if (!this.validateEmail(emailToSend)) {
          this.sendError = 'Please enter a valid email address';
          return;
        }
        
        this.sending = true;
        this.success = null;
        this.sendError = null;
        
        // Send invitation request
        axios.post(`/${this.slug}/Employee/invitation/send`, {
          email: emailToSend
        })
        .then(response => {
          console.log("Invitation sent:", response.data);
          this.success = response.data.message || "Invitation sent successfully!";
          this.sending = false;
          
          // If there's a redirect URL, navigate to it after a short delay
          if (response.data.redirect) {
            setTimeout(() => {
              window.location.href = response.data.redirect;
            }, 1500);
          } else {
            // Otherwise just close the popup after 2 seconds
            setTimeout(() => {
              this.closePopup();
              this.$emit('send', emailToSend);
            }, 2000);
          }
        })
        .catch(error => {
          console.error("Error sending invitation:", error);
          this.sendError = error.response?.data?.message || "Failed to send invitation. Please try again.";
          this.sending = false;
        });
      } else {
        this.sendError = 'Please enter an email or select a user';
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    closePopup() {
      this.email = '';
      this.selectedUser = '';
      this.success = null;
      this.sendError = null;
      this.$emit('update:visible', false);
    }
  },

  mounted() {
    console.log("Component mounted with slug:", this.slug);
  }
};
</script>

<style scoped>
.popup-content {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>